export const getChipOverrides = (theme, typography) => {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          ...typography.body.caption,
          paddingTop: 4,
          paddingBottom: 4,
          height: 26,
          minWidth: 90,
          color: theme.palette.secondary.contrastText
        }
      }
    }
  };
};